"use strict";
/**
 *
 * ACTIONS
 *
 * This is where we should keep all consts for log events
 */
const account = {
    LOG_ON: 'account-logon',
    LOG_OFF: 'account-logoff',
    CONNECTED: 'account-auth',
    UNAUTHORIZED_LOGIN: 'account-login-unauthorized',
    REGISTER: 'account-register',
    ADD: 'account-organization-add',
    CREATE: 'account-create',
    ATA_READ: 'account-ata-read',
    ATA_UPDATE: 'account-ata-update',
    PROFILE_READ: 'account-profile-read',
    PROFILE_UPDATE: 'account-profile-update',
    REMOVE: 'account-remove',
    DESTORY: 'account-destroy', // Actual delete a user by its mean, only by Admin users
};
const note = {
    READ: 'note-read',
    CREATE: 'note-create',
    UPDATE: 'note-update',
    DELETE: 'note-delete',
};
const pinnedNote = {
    CREATE: 'pinnednote-create',
    UPDATE: 'pinnednote-update',
};
const reminder = {
    READ: 'reminder-read',
    CREATE: 'reminder-create',
    UPDATE: 'reminder-update',
    DELETE: 'reminder-delete',
};
const formSchema = {
    READ: 'form-schema-read',
    CREATE: 'form-schema-create',
    UPDATE: 'form-schema-update',
    DELETE: 'form-schema-delete',
    STAFF_ADD: 'form-staff-add',
    STAFF_REMOVE: 'form-staff-remove',
    STAFF_READ: 'form-staff-read',
    USER_ADD: 'form-user-add',
    USER_REMOVE: 'form-user-remove',
    USER_READ: 'form-user-read',
};
const formSubmission = {
    CREATE: 'form-submission-create',
    READ: 'form-submission-read',
    UPDATE: 'form-submission-update',
    DELETE: 'form-submission-delete',
    LOCK: 'form-submission-lock',
    FILE_UPLOAD: 'form-submission-file-upload',
};
const workflowSchema = {
    READ: 'workflow-schema-read',
    CREATE: 'workflow-schema-create',
    UPDATE: 'workflow-schema-update',
    DELETE: 'workflow-schema-delete',
};
const workflow = {
    CREATE: 'workflow-create',
    LIST_READ: 'workflow-list-read',
    DETAIL_READ: 'workflow-detail-read',
    UPDATE: 'workflow-update',
    FINISH: 'workflow-finish',
    FILE_UPLOAD: 'workflow-file-upload',
    AUTOSTART: {
        READ: 'workflow-autostart-read',
        SET: 'workflow-autostart-set',
        REMOVE: 'workflow-autostart-remove',
    },
    ACTION_SUBMIT: 'workflow-action-submit',
};
const resourceSchema = {
    READ: 'resource-schema-read',
    CREATE: 'resource-schema-create',
    UPDATE: 'resource-schema-update',
    DELETE: 'resource-schema-delete',
    USER_READ: 'resource-user-access-read',
    USER_UPDATE: 'resources-user-access-update',
};
const healthIndicatorSchema = {
    READ: 'health-indicator-schema-read',
    CREATE: 'health-indicator-schema-create',
    UPDATE: 'health-indicator-schema-update',
    DELETE: 'health-indicator-schema-delete',
};
const healthIndicator = {
    READ: 'health-indicator-read',
    CREATE: 'health-indicator-create',
};
const call = {
    VIDEO: 'call-initiate-video',
    AUDIO: 'call-initiate-audio',
    CONFERENCE: 'call-conference',
    SILENT: 'call-initiate-silent',
    READ: 'call-read',
    RECEIVED: 'call-received',
};
const meeting = {
    CREATE: 'meeting-create',
    INVITE: 'meeting-invite',
    JOIN: 'meeting-join',
    LEAVE: 'meeting-leave',
    GET: 'meeting-get',
};
const message = {
    GET: 'message-get',
    SEND: 'message-send',
    SEND_FILE: 'message-send-file',
    READ: 'message-read',
    MISSED: 'message-read-missed',
    AUTOREPLY_READ: 'message-read-autoreply',
};
const emr = {
    READ: 'emr-read',
    RECEIVE: 'emr-receive',
    RESPONSE: 'emr-response',
};
const thresholds = {
    UPDATE: 'thresholds-update',
    READ: 'thresholds-read',
};
const manage = {
    MANAGE_PERMISSION_READ: 'manager-permission-read',
    MANAGE_PERMISSION_UPDATE: 'manager-permission-update',
    MANAGE_ADD: 'manager-add',
    MANAGE_REMOVE: 'manager-remove',
    MANAGE_READ: 'manager-read',
};
const staff = {
    REMOVE: 'staff-remove',
    ADD: 'staff-add',
    READ: 'staff-read',
    SETTINGS_UPDATE: 'staff-settings-update',
    SETTINGS_READ: 'staff-settings-read',
};
const urgency = {
    UPDATE: 'urgency-settings-update',
    READ: 'urgency-settings-read',
    CONTACT_ADD: 'urgency-contacts-add',
    CONTACT_REMOVE: 'urgency-contacts-remove',
    CONTACT_READ: 'urgency-contacts-read',
};
const contacts = {
    READ: 'contacts-read',
};
const atouchaway = {
    READ: 'atouchaway-settings-read',
    UPDATE: 'atouchaway-settings-update',
};
const reports = {
    DOWNLOAD: 'reports-download',
    LIST: 'reports-list',
};
const org = {
    MANAGER_ADD: 'org-manager-add',
    MANAGER_REMOVE: 'org-manager-remove',
};
const patientGroups = {
    READ: 'patient-groups-read',
    CREATE: 'patient-groups-create',
    UPDATE: 'patient-groups-update',
    UPDATE_PERMISSIONS: 'patient-groups-update-permissions',
    DELETE: 'patient-groups-delete',
    MANAGER_ADD: 'patient-groups-manager-add',
    BULK_MANAGER_ADD: 'patient-groups-bulk-manager-add',
    MANAGER_REMOVE: 'patient-groups-manager-remove',
    BULK_MANAGER_REMOVE: 'patient-groups-bulk-manager-remove',
    PATIENT_ADD: 'patient-groups-patient-add',
    PATIENT_REMOVE: 'patient-groups-patient-remove',
};
module.exports = {
    account,
    note,
    reminder,
    formSchema,
    formSubmission,
    pinnedNote,
    call,
    message,
    workflowSchema,
    workflow,
    resourceSchema,
    healthIndicatorSchema,
    healthIndicator,
    emr,
    thresholds,
    contacts,
    urgency,
    staff,
    manage,
    atouchaway,
    reports,
    meeting,
    org,
    patientGroups,
};
//# sourceMappingURL=actions.js.map